import React from 'react';
import iconSizes from 'constants/iconSizes.js';

const style = {
  display: 'inline-block',
  userSelect: 'none',
  flexShrink: 0,
};

const ExclamationIcon = ({ size = 'xsl', color = 'black', style: overrideStyles = {}, ...attr }) => {

  return (
    <svg style={{ ...style, ...overrideStyles }} {...iconSizes[size]} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...attr}>
      <path
        d="M4 12C4 7.58172 7.58172 4 12 4C16.4183 4 20 7.58172 20 12C20 16.4183 16.4183 20 12 20C7.58172 20 4 16.4183 4 12ZM12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2ZM11 6V14H13V6H11ZM12 15C11.1716 15 10.5 15.6716 10.5 16.5C10.5 17.3284 11.1716 18 12 18C12.8284 18 13.5 17.3284 13.5 16.5C13.5 15.6716 12.8284 15 12 15Z"
        fill={color}
      />
    </svg>
  );
};

export default ExclamationIcon;
